<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addWxAccount"/>
        <!--<button-delete @deleteSelection="deleteSelection" />-->
      </div>
      <input-search placeholder="商户号" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" :deleteTipInfo="'是否确认删除常用电话？'" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" />


  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/Config'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nAlert, nError, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'wx-account-manage',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '配置中心',
          name: 'config-basic'
        }, {
          value: '微信账户配置'
        }],
        addWxAccount: 'wx-account-add',
        operationArr: ['modify'],
        tableHead: [{
          prop: 'mchId',
          label: '商户号'
        }, {
          prop: 'mchName',
          label: '商户名称'
        }, {
          prop: 'mchKey',
          label: '商户密钥'
        }, {
          prop: 'subMchId',
          label: '特约商商户号'
        }, {
          prop: 'purposeText',
          label: '用途'
        }],
        tableData: [],
        total: 0,
        selectionArr: [],
        requestData: {
          searchKey: '',
          pageSize: 10,
          pageNum: 1,
        },
        dialogFormVisible: false,
        videoInfo: {}
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    methods: {
      getPage () {
        this.$axios.post(api.getWxDepositAccountPage, this.requestData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                if (v.purpose === '1') {
                  v.purposeText = '人脸'
                } else if (v.purpose === '2') {
                  v.purposeText = '物业'
                } else if (v.purpose === '3') {
                  v.purposeText = '维修'
                } else if (v.purpose === '4') {
                  v.purposeText = '停车'
                } else if (v.purpose === '5') {
                  v.purposeText = '场地'
                } else if (v.purpose === '6') {
                  v.purposeText = '电费'
                } else if (v.purpose === '7') {
                  v.purposeText = '租金'
                } else if (v.purpose === '9') {
                  v.purposeText = '水费'
                } else if (v.purpose === '8') {
                  v.purposeText = '空调费'
                }
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取数据失败'))
      },
      search (v) {
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.requestData.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.requestData.pageNum = data[0]
        this.requestData.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      goToModifyPage (code) {
        let model = ''
        let mchId = ''
        let mchName = ''
        let mchKey = ''
        let subMchId = ''
        let purpose = ''

        this.tableData.map(v => {
          if (v.code === code) {
            model = v.model
            mchId = v.mchId
            mchName = v.mchName
            mchKey = v.mchKey
            subMchId = v.subMchId
            purpose = v.purpose
          }
        })
        console.log({
          code,
          model,
          mchId,
          mchName,
          mchKey,
          subMchId,
          purpose,
        })
        this.$router.push({
          name: `wx-account-modify`,
          params: {
            code,
            model,
            mchId,
            mchName,
            mchKey,
            subMchId,
            purpose,
          }
        })

        // this.dialogFormVisible = true
      },
      updateParkVideo () {
        if (!this.videoInfo.header) {
          nError('请输入宣传标题')
          return false
        }
        this.$axios.post(api.updateParkVideo, this.videoInfo)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.dialogFormVisible = false
              this.getPage()
            }
          })
          .catch(errorHandler('修改宣传信息失败'))
      },
      deleteSelection () {
        if (this.selectionArr.length === 0) {
          nAlert('请先选择需要删除的宣传视频')
          return false
        } else {
          this.$confirm('是否确认删除宣传视频？', '提示')
            .then(() => {
              this.deleteLine(this.selectionArr)
            })
            .catch(() => {
              console.log('取消删除')
            })
        }
      },
      deleteLine (code) {
        this.$axios.post(api.deletePhoneByCodes, code)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('删除成功')
              this.selectionArr = []
              this.getPage()
            }
          })
          .catch(errorHandler('删除失败'))
      }
    },
    watch: {
      centEndTime(val) {
        this.getPage()
      }
    }
  }
</script>

<style scoped>
  .form-line {
    width: 420px;
    margin: 20px auto;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .red {
    color: red;
  }
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/view/ConfigCenter/wxAccountConfig/wxAccountManage.vue